<template>
  <div style="overflow: hidden">
    <div id="home-view">
      <dv-full-screen-container>
        <div class="home-header">
          <div class="homeHeader-left-decoration">
            <dv-decoration8/>
            <div class="decoration-left">
              <el-select @change="changeDevice($event)" filterable v-model="deviceDefault">
                <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in deviceBoards">
                  <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
          </div>
          <dv-decoration5 class="homeHeader-center-decoration"/>
          <div class="homeHeader-right-decoration">
            <div class="decoration-left" :style="weatherDisplay()">
              <div class="decorationLeft-weather-left" >
                <p><img :src="weatherImg"></p>
                <p>{{weatherAddress}}</p>
              </div>
              <div class="decorationLeft-weather-right">
                <span>{{nowDate}}&#12288{{weatherType}}</span>
                <div>
                  <span>温度：{{lowTemp}} ~ {{upTemp}}</span><br/>
                  <span>风向：{{windDirection}}&#12288风力：{{windPower}}</span>
                </div>
              </div>
            </div>
            <dv-decoration-8 :reverse="true"/>
            <div class="decoration-right">
              <el-button @click="logout">{{$t("logout")}}</el-button>
              <div class="decorationRight-header-email">
                {{email}}
              </div>
            </div>
          </div>
          <div class="homeHeader-center">
            {{$t("platform")}}
          </div>
        </div>
        <dv-decoration-10 class="homeHeader-dv"/>
        <div class="home-contain" >
          <div class="home-contain-left" :class="findKey == false ? 'form-onlyRead':''">
            <real-data :lineInfo="offLine" ref="realData"/>
          </div>
          <div class="home-contain-right">
<!--            <statistical-data ref="statisticalData"/>-->
            <div class="map-device">
              <div class="map-left">
                <map-data @callBack="handleInfo" @callOffLine="getConnectionTime" ref="mapData"/>
              </div>
              <div class="device-right" :class="findKey == false ? 'form-onlyRead':''">
                <day-rain ref="dayRain" />
              </div>
            </div>
            <div class="statistical" :class="findKey == false ? 'form-onlyRead':''">
              <statistical-data ref="statisticalData"/>
            </div>
          </div>
        </div>
      </dv-full-screen-container>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import realData from "./RealData"
  import statisticalData from "./StatisticalData";
  import mapData from "./MapData";
  import dayRain from "./DayRain"
  import axios from "axios";
  import {
    getAdminDevice,
    getCustomerDevice,
    getCredentials,
    getAttributesShared,
    getDeviceKey, getConnectTime
  } from "../untils/api/home"
  import router from "../router/index"
  import {userLogin} from "../untils/api/login";
  export default {
    name: 'Home',
    components: {
      realData,
      statisticalData,
      mapData,
      dayRain
    },
    data() {
      return {
        deviceDefault: '',
        deviceBoards:[],
        weatherImg: require('./img/wether.png'),
        weatherCode: '',
        weatherAddress: '',
        nowDate: '',
        weatherType: '',
        lowTemp: '',
        upTemp: '',
        windDirection: '',
        windPower: '',
        email:'',
        findKey: true,
        tokenTime: null,
        deviceInfo: {},
        offLine: 0,
        key: 'rainfall',
        // key: 'rainfallf',
        // key: 'rainfallg',
        // key: 'rainfally1',
        credentialsId: '',
      }
    },
    mounted() {
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId == undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      //获取用户名
      this.email = this.$route.params.email == undefined ? localStorage.getItem('email') : this.$route.params.email;

      if(authority === 'TENANT_ADMIN'){
        //管理员租户
        getAdminDevice().then(response => {
          //获取设备列表
          this.setDeviceBoards(response, authority);
        }).catch(error => {
          console.log("error",error)
        })
      } else {
        // 普通租户
        getCustomerDevice(customerId).then(response => {
          //获取设备列表
          this.setDeviceBoards(response, authority);
        }).catch(error => {
          console.log("error",error)
        })
      }
    },

    methods: {
      /**
       * 获取设备列表
       * @param deviceTotal
       */
      setDeviceBoards(deviceTotal, authority) {
        if(authority === 'TENANT_ADMIN') {
          if(deviceTotal.data.length === 0) return;
          for(let i = 0; i < deviceTotal.data.length; i++) {
            let item = {};
            item.id = deviceTotal.data[i].id.id;
            item.name = deviceTotal.data[i].name;
            item.type = deviceTotal.data[i].id.entityType;
            this.deviceBoards.push(item);
          }
          //每隔2小时更新一次token
          this.getDeviceToken();
          //默认选中第一个设备
          this.deviceDefault = this.deviceBoards[0].id;
          //获取设备类型以及id
          this.deviceTypeId();

          this.$refs.mapData.getDeviceSite(this.deviceBoards, this.key);
          this.$refs.realData.getDeviceLine(this.deviceBoards);
        } else {
          if(deviceTotal.data.length === 0) return;
          let promises = [];
          for(let i = 0; i < deviceTotal.data.length; i++) {
            let item = {
              id: deviceTotal.data[i].id.id,
              name: deviceTotal.data[i].name,
              type: deviceTotal.data[i].id.entityType
            };

            let promise = getConnectTime(item.type, item.id).then(response => {
              let time = response[0].value;
              let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
              item.state = time < beforeTime ? 'red' : 'green';
              return item;
            });

            promises.push(promise);
          }

          Promise.all(promises).then(results => {
            this.deviceBoards = results;
            //每隔2小时更新一次token
            this.getDeviceToken();
            //默认选中第一个设备
            this.deviceDefault = this.deviceBoards[0].id;
            //获取设备类型以及id
            this.deviceTypeId();

            this.$refs.mapData.getDeviceSite(this.deviceBoards, this.key);
            this.$refs.realData.getDeviceLine(this.deviceBoards);
          })
        }
      },

      /**
       * 每隔2小时更新一次token
       */
      getDeviceToken() {
        this.tokenTime = window.setInterval(() => {
          setTimeout(() => {
            this.getWeatherInfo();
            let paramJson = JSON.parse(localStorage.getItem('rainLogin'));
            userLogin(paramJson).then(response => {
              localStorage.setItem('rainToken',response.token);
            }).catch(error => {
              console.log("error",error)
            })
          },0)
        }, 1000 * 60 * 60 * 2)
      },

      /**
       * 选中设备的信息
       * @param event
       */
      changeDevice(event) {
        this.deviceDefault = event;
        //获取设备类型以及id
        this.deviceTypeId();
      },

      handleInfo(data) {
        this.deviceDefault = data.id;
        this.deviceTypeId();
      },

      getConnectionTime(data) {
         this.offLine = data
      },

      /**
       * 获取设备类型以及id
       */
      deviceTypeId() {
        getCredentials(this.deviceDefault).then(response => {
          this.deviceInfo = response.deviceId;
          this.credentialsId = response.credentialsId;
          this.$refs.realData.iniRealData(this.deviceInfo, this.key);//初期化实时雨量画面
          this.$refs.statisticalData.iniHistory(this.deviceInfo, this.key);//初期化统计雨量画面
          this.$refs.dayRain.iniDayRain(this.deviceInfo, this.credentialsId, this.key);//初期化日雨量画面
          this.deviceKeyInfo();//获取设备key

          this.getWeatherAddress();//获取天气地址
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 判断是否存在雨量
       */
      deviceKeyInfo() {
        getDeviceKey(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
          if(response.indexOf(this.key) > -1){
            this.findKey = true;
            this.$refs.realData.getHistoryInfo();//获取1小时内历史遥测雨量数据
            this.$refs.realData.getLastHour();//获取前一小时内历史遥测雨量数据
            this.$refs.statisticalData.iniMinuteHistory();  //五分钟之内雨量
            this.$refs.statisticalData.iniDayHistory();//将一天数据传递到统计数据内
            this.$refs.dayRain.getBoundary();//获取日雨量分界线
          } else {
            this.findKey = false;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t('deviceError')
            });
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取天气预报地址
       */
      getWeatherAddress() {
        this.weatherCode = '';
        this.weatherAddress = '';
        getAttributesShared(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key === 'rain_Address'){
              this.weatherCode = response[i].value;
              this.getWeatherInfo();
              break;
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取天气预报
       */
      async getWeatherInfo(){
        if(this.weatherCode !== ''){
          let url = 'weather/city/' + this.weatherCode;
          return await axios({
            method: 'get',
            baseURL: process.env.Weather,
            url,
            header: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: 1000
          }).then(response => {
            this.nowDate = moment().format("YYYY-MM-DD");
            this.weatherAddress = response.cityInfo.city.toString().substring(0,response.cityInfo.city.length - 1);
            this.weatherType = response.data.forecast[0].type;
            this.upTemp = response.data.forecast[0].high.toString().split(' ')[1];
            this.lowTemp = response.data.forecast[0].low.toString().split(' ')[1];
            this.windDirection  = response.data.forecast[0].fx;
            this.windPower = response.data.forecast[0].fl;
          }).catch(error => {
            this.weatherCode = '';
            console.log("error", error);
          })
        }
      },
      /**
       * 天气预报模块是否显示
       */
      weatherDisplay() {
        if(this.weatherCode === ''){
          return {
            display:'none'
          }
        }
      },

      /**
       * 退出
       */
      logout() {
        let local = localStorage.getItem('locale');
        localStorage.clear();
        clearInterval(this.tokenTime);
        this.tokenTime = null;
        localStorage.setItem('locale',local);
        router.replace('/')
      }
    }
  }
</script>

<style lang="less">
  @import "less/Home";
</style>

<style>
  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue